<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12>
        <div class="px-4 pb-3 my-4">
          <v-btn style="position: absolute; top: 0px; right: 5px" @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">ประวัติการสั่งซื้อ</div> -->
          <h3 class="headline">ประวัติการสั่งซื้อ</h3>
          <!-- :pagination.sync="pagination" -->
          <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  <template v-if="props.item.timestamp">
                    {{ props.item.timestamp | DateFormat('DD/MM/YYYY - hh.mm') }} น.
                  </template>
                </td>
                <td colspan="3">
                  <template v-for="(item, index) in JSON.parse(props.item.productdetail)">
                    <v-layout row wrap :key="index" class="ma-0 py-2">
                      <v-flex xs7> <v-icon>circle-small</v-icon> {{ item.name }} </v-flex>
                      <v-flex xs3 class="pl-4">
                        {{ item.quantity }}
                      </v-flex>
                      <v-flex xs2 class="pl-3">
                        {{ item.price | numberFormat }}
                      </v-flex>
                    </v-layout>
                  </template>
                </td>
                <td>
                  <!-- {{ props.item.address || '-' }} -->
                  {{ props.item.shippingcharge | numberFormat }}
                </td>
                <td>{{ props.item.amount | numberFormat }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: ['edittype', 'editdata', 'userid'],
  components: {},
  data() {
    return {
      saveloading: false,
      loading: false,
      offset: 0,
      limit: 10,
      headers: [
        { text: 'วัน/เวลา', value: 'timestamp', width: '4%', sortable: false },
        { text: 'รายการสินค้า', value: 'product', width: '8%', sortable: false },
        { text: 'จำนวน', value: 'quantity', width: '1%', sortable: false },
        { text: 'ราคาสินค้า', value: 'price', width: '1%', sortable: false },
        { text: 'ค่าจัดส่ง', value: 'shippingcharge', width: '1%', sortable: false },
        { text: 'ยอดรวม', value: 'amount', width: '1%', sortable: false }
      ],
      data: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getHistoryOrdersData()
  },
  methods: {
    getHistoryOrdersData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        userid: this.userid,
        limit: this.limit,
        offset: this.offset
      }
      api.foodguruGetcustomerOrders(data, (err, response) => {
        if (response.responsecode == 200) {
          this.data = response.data
          this.loading = false
        } else {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/foodguru/OrderHistory.vue